import { AbstractComponent } from "appworks/components/abstract-component";
import { Layers } from "appworks/graphics/layers/layers";
import { Text } from "appworks/graphics/pixi/text";
import { pulse } from "appworks/utils/animation/scale";
import { Contract } from "appworks/utils/contracts/contract";
import { Easing } from "appworks/utils/tween";
import { SlingoSpinType } from "slingo/integration/slingo-schema";

export class SlingoSpinsCounterComponent extends AbstractComponent {
    protected layer: Layers;
    protected text: Text;
    protected value: number = -1;

    constructor(protected layerName: string) {
        super();
    }

    public init(): void {
        this.layer = Layers.get(this.layerName);
        this.layer.onSceneEnter.add(() => this.getText());
        this.getText();
    }

    public setValue(spins: number, animate: boolean = true): Contract {
        if (spins === this.value) {
            animate = false;
        }

        this.value = spins;
        this.text.text = spins.toString();

        return animate ? this.animate() : Contract.empty();
    }

    public increment(animate: boolean = true): Contract {
        return this.setValue(this.value + 1, animate);
    }

    public decrement(animate: boolean = true): Contract {
        return this.setValue(this.value - 1, animate);
    }

    public setType(type: SlingoSpinType): Contract {
        if (this.layer.hasScene(type)) {
            return this.layer.setScene(type);
        }
        return this.layer.defaultScene();
    }

    protected getText() {
        this.text = this.layer.getText("spins_remaining_value");
        this.text.text = this.value.toString();
    }

    protected animate(): Contract {
        this.text.landscape.scale.set(1);
        this.text.portrait.scale.set(1);

        return pulse(this.text, { x: 1.2, y: 1.2 }, 150, Easing.Sinusoidal.Out);
    }
}
